import { Link } from "react-router-dom";
import { novels } from "@/mocks/novels";
import { getHotRanking, getLatestUpdates, toNovel } from "@/lib/novel";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import SectionHeading from "@/components/base/SectionHeading";
import NovelCard from "@/components/base/NovelCard";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import HotRanking from "@/pages/home/components/HotRanking";

const featuredIds = ["wan-gu-shen-di", "jian-lai-jiu-tian", "mo-dao-qing-tian", "xing-ji-yuan-zheng"];

export default function Home() {
  useDocumentMeta(
    "御书屋 - 高清小说阅读平台，最新最全网络小说推荐",
    "御书屋提供丰富多样的小说资源，涵盖玄幻、言情、历史等多个分类，满足读者多样化阅读需求，支持在线阅读与章节浏览。",
  );

  const featured = featuredIds
    .map((id) => novels.find((item) => item.id === id))
    .filter((item): item is (typeof novels)[number] => Boolean(item))
    .map(toNovel);

  const latest = getLatestUpdates(6);
  const ranking = getHotRanking(8);

  return (
    <div>
      <HeroCarousel items={featured} />

      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          title="分类快捷入口"
          subtitle="按题材找到属于你的下一本好书"
          icon="ri-apps-2-line"
          to="/category/xuanhuan"
          linkLabel="进入书架"
        />
        <CategoryGrid />
      </div>

      <div className="bg-background-50">
        <div className="w-full px-4 py-10 md:px-8 md:py-14">
          <SectionHeading
            title="最新更新"
            subtitle="刚刚更新的章节，追更不落队"
            icon="ri-time-line"
            to="/category/xuanhuan"
          />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {latest.map((novel) => (
              <NovelCard key={novel.id} novel={novel} />
            ))}
          </div>
        </div>
      </div>

      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          title="热门小说排行榜"
          subtitle="按阅读热度排序，读者都在看"
          icon="ri-fire-line"
        />
        <HotRanking items={ranking} />
      </div>

      <div className="w-full px-4 pb-4 md:px-8">
        <div className="flex flex-col items-start justify-between gap-4 rounded-lg bg-primary-900 px-6 py-8 md:flex-row md:items-center">
          <div>
            <h2 className="font-heading text-xl font-bold text-background-50">
              关于御书屋
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-300">
              我们相信好的阅读体验值得被认真对待。御书屋以清爽的排版、稳定的章节导航与贴心的阅读设置，
              陪伴你把每一个故事读完。
            </p>
          </div>
          <Link
            to="/about"
            className="flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
          >
            了解更多
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}